enum JobSectionGroup {
  IGNORE,
  BOOKING,
  NORMAL,
  GOOD,
  CAUTION,
  BAD
}

export default JobSectionGroup;